import { render, staticRenderFns } from "./RequestNameplate.vue?vue&type=template&id=367295ed&scoped=true"
import script from "./RequestNameplate.vue?vue&type=script&lang=js"
export * from "./RequestNameplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367295ed",
  null
  
)

export default component.exports